/**
 * Server sessiyasi yo'q holat (token yo'q): ilova faqat Telegram ichida va serverga ulanib ishlaydi,
 * localStorage'dagi "offline onboarding" yo'q — aks holda ism/so'rovnoma serverga yetmaydi va har ochganda takrorlanadi.
 *  - 'telegram': auth 401 (initData yo'q yoki noto'g'ri bot) → Telegram'da ochish havolasi.
 *  - 'offline':  server javob bermadi → qayta urinish.
 */
import { t } from '../i18n';

const BOT = (import.meta.env.VITE_BOT_USERNAME as string | undefined) || 'lexocard_bot';

export function Gate({ kind }: { kind: 'telegram' | 'offline' }) {
  const tg = kind === 'telegram';
  return (
    <div className="content fade" style={{ padding: '48px 24px 24px', gap: 22, justifyContent: 'center' }}>
      <div className="col g14" style={{ alignItems: 'center', textAlign: 'center' }}>
        <div className="logo">L<i /></div>
        <h1 className="h2">{tg ? t('Lexo Telegram ichida ishlaydi') : t('Server bilan aloqa yoʻq')}</h1>
        <p className="sub">
          {tg
            ? t('Ilovani Telegram botidan oching — progressingiz Telegram hisobingizga bogʻlanadi va hech qachon yoʻqolmaydi.')
            : t('Internetni tekshiring va qayta urinib koʻring.')}
        </p>
      </div>
      {tg
        ? <a className="btn" href={`https://t.me/${BOT}`} style={{ textDecoration: 'none' }}>{t('Telegramʼda ochish')}</a>
        : <button className="btn" onClick={() => location.reload()}>{t('Qayta urinish')}</button>}
    </div>
  );
}
